import { render, staticRenderFns } from "./GptSuggestionModal.vue?vue&type=template&id=c5324644&"
import script from "./GptSuggestionModal.vue?vue&type=script&lang=js&"
export * from "./GptSuggestionModal.vue?vue&type=script&lang=js&"
import style0 from "./GptSuggestionModal.vue?vue&type=style&index=0&id=c5324644&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports